import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Flex,
  Input,
} from '@chakra-ui/react'
import { useState } from 'react'

export const MenuSegmento = ({ segmentos, onSelectedSegmentos, seg }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [filteredSegmentos, setFilteredSegmentos] = useState(segmentos)

  const handleFilterSegmentos = (e) => {
    const value = e.target.value
    const filtered = segmentos.filter((category) => category.descricao.toLowerCase().includes(value.toLowerCase()))
    setFilteredSegmentos(filtered)
  }

  function handleSelectedCategory(category) {
    onSelectedSegmentos(category)
    onClose()
  }

  return (
    <>
      <Button 
        onClick={onOpen}
        colorScheme='green'
      >
        {seg ? seg : 'Selecione um Segmento'}
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Selecione uma Categoria</ModalHeader>
          <ModalCloseButton />
          <ModalBody
            display='grid'
            gridTemplateColumns='repeat(3, 1fr)'
            gap={4}
          >
            <Flex
              gridColumn='1 / 4'
              justifyContent='center'
              mb={4}
            >
              <Input
                placeholder='Pesquise um segmento'
                onChange={handleFilterSegmentos}
              />
            </Flex>

            {filteredSegmentos?.map((category) => (
              <Button 
                key={category.codigo_segmento} 
                variant='outline' 
                colorScheme='blue'
                onClick={() => handleSelectedCategory(category)}
              >
                {category.descricao}
              </Button>
            ))}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button variant='ghost'>Confirmar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}